import React, { useRef, useState, useEffect } from 'react';
import classes from '../Register/Register.module.css';
import fl_logo from '../../assets/fl_logo.png';
import { EmailOutlined } from '@material-ui/icons';
import CustomTextField from '../../ui/CustomTextField';
import CustomButton from '../../ui/CustomButton';
import CustomSpinner from '../../ui/CustomSpinner';
import useV3Axios from '../../hooks/useV3Axios';
import { useHistory } from 'react-router-dom';
import { LOGIN_PATH } from '../../utils/paths';

const ForgotPassword = () => {
    const emailRef = useRef(null);
    const [submitted, setSubmitted] = useState(false);
    const history = useHistory();

    const { isLoading, data, sendRequest } = useV3Axios();

    useEffect(() => {
        // Always show success — prevents email enumeration
        if (data) setSubmitted(true);
    }, [data]);

    const handleSubmit = (event) => {
        event.preventDefault();
        sendRequest('/auth/request-password-reset', { email: emailRef.current.value.trim() });
    };

    return (
        <div className={classes.Login}>
            <div className={classes.Card}>
                <img className={classes.Logo} src={fl_logo} alt="logo" />
                <p className={classes.Title}>FetalLite Dashboard</p>
                {!submitted ? (
                    <form className={classes.Form} onSubmit={handleSubmit}>
                        <h3 style={{ textAlign: 'left', margin: '0 0 8px 0', color: '#333' }}>Reset your password</h3>
                        <p style={{ textAlign: 'left', fontSize: '14px', color: '#555', margin: '0 0 16px 0' }}>
                            Enter your email address and we'll send you a reset link.
                        </p>
                        <CustomTextField margin="10px auto" reference={emailRef} required id='email' label='Email address' type='email'>
                            <EmailOutlined />
                        </CustomTextField>
                        <div className={classes.Container}>
                            {isLoading ? <CustomSpinner /> : <CustomButton type='submit' size='large'>SEND RESET LINK</CustomButton>}
                        </div>
                        <hr className={classes.Divider} />
                        <p style={{ textAlign: 'center', fontSize: '14px', color: '#555' }}>
                            <span className={classes.Link} onClick={() => history.push(LOGIN_PATH)}>Back to sign in</span>
                        </p>
                    </form>
                ) : (
                    <div className={classes.Form}>
                        <h3 style={{ textAlign: 'left', color: '#333' }}>Check your email</h3>
                        <p className={classes.Success}>
                            If an account with that email exists, a password reset link has been sent. Check your inbox — the link expires in 1 hour.
                        </p>
                        <div className={classes.Container}>
                            <CustomButton type='button' size='large' onClick={() => history.push(LOGIN_PATH)}>
                                BACK TO SIGN IN
                            </CustomButton>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
